import { Checkbox } from 'antd';
import type { AdditionalOptionsFilterProps } from '../reports.types';

const options = [
  {
    label: 'Показать % правильных ответов',
    value: 'correctnessRate',
  },
  {
    label: 'Показать ошибки по вопросам',
    value: 'questionErrors',
  },
];

const AdditionalOptionsFilter = ({ selectedContent, onChange }: AdditionalOptionsFilterProps) => {
  return (
    <>
      Дополнительные опции:
      <div style={{ marginTop: 7, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {options.map((option) => (
          <div key={option.value} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Checkbox
              checked={selectedContent.includes(option.value)}
              onChange={(e) => onChange(option.value, e.target.checked)}
            />
            <span style={{ userSelect: 'none', fontSize: '14px' }}>{option.label}</span>
          </div>
        ))}
      </div>
    </>
  );
};

export default AdditionalOptionsFilter;